import axios from "axios";
import moment from "moment";

const baseURL =
  process.env.REACT_APP_NEW_IMAGE_UPLOAD_URL;
//  ||"https://files.suprabhaatham.com/upload";

export const uploadImageToS3 = async (file: any) => {
  const formData = new FormData();
  const filename = `${moment().format("YYYY-MM-DDHH:MM:SS")}${file?.name}`;
  formData.append("image", file, filename);
  return axios.post(`${baseURL}`, formData);
};

export const uploadInsnap = async (files: any) => {
  const uploadPromises = files.map(async (item: any) => {
    const filename = `${moment().format("YYYY-MM-DDHH:MM:SS")}${item?.name}`;

    const formData = new FormData();
    formData.append("image", item?.originFileObj, filename);
    return axios.post(`${baseURL}/insnap`, formData);
  });
  return Promise.all(uploadPromises);
};

export const uploadPodcast = async (file: any) => {
  const formData = new FormData();
  const filename = `${moment().format("YYYY-MM-DDHH:MM:SS")}${file?.name}`;

  formData.append("image", file, filename);
  return axios.post(`${baseURL}/podcast`, formData);
};
export const uploadImageToS3banner = async (file: any) => {
  const formData = new FormData();
  const filename = `${moment().format("YYYY-MM-DDHH:MM:SS")}${file?.name}`;

  formData.append("image", file, filename);
  return axios.post(`${baseURL}/banners`, formData);
};

export const uploadAudioToS3 = async (file: any) => {
  const formData = new FormData();
  const filename = `${moment().format("YYYY-MM-DDHH:MM:SS")}${file?.name}mp3`;

  formData.append("file", file, filename);
  return axios.post(`${baseURL}/audio`, formData);
};
export const uploadVideoToS3 = async (file: any) => {
  const formData = new FormData();
  const filename = `${moment().format("YYYY-MM-DDHH:MM:SS")}${file?.name}`;

  formData.append("file", file, filename);
  return axios.post(`${baseURL}/video`, formData);
};

export const uploadImageToS3WebStories = async (file: any) => {
  const formData = new FormData();
  const filename = `${moment().format("YYYY-MM-DDHH:MM:SS")}${file?.name}`;

  formData.append("image", file, filename);
  return axios.post(`${baseURL}/webstories`, formData);
};

export const uploadPdfImageToS3 = async (file: any, filename: any) => {
  const formData = new FormData();
  formData.append("image", file, filename);
  return axios.post(`${baseURL}/pdfimage`, formData);
};

export const getImagesFromBucket = async (bucketPath = "") => {
  try {
    const response = await axios.get(`${baseURL}/list?path=${bucketPath}`);
    return response.data.files;
  } catch (error) {
    console.error("Error fetching images:", error);
    return [];
  }
};
